module.exports = __webpack_public_path__ + "img/bilge-pump-off.acc003c6.svg";